import { Link } from "@tanstack/react-router";
import logoAsset from "@/assets/double-lion-logo-561.png.asset.json";
import logoAssetWebp from "@/assets/double-lion-logo-561.webp.asset.json";
import { OWNERS_MANUAL } from "@/lib/manual";


export function SiteFooter() {
  return (
    <footer className="w-full bg-[#001e4a] text-white/85 shadow-[0_20px_60px_-20px_rgba(0,0,0,0.45)] ring-1 ring-white/5 overflow-hidden min-h-[360px] sm:min-h-[320px] md:min-h-[300px]">
      <div className="px-5 sm:px-8 md:px-12 py-8 sm:py-10 md:py-12">


        {/* Main grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-12 gap-8 sm:gap-8 md:gap-8">
          {/* Brand + mark */}
          <div className="min-w-0 sm:col-span-2 md:col-span-4">
            <picture>
              <source type="image/webp" srcSet={logoAssetWebp.url} />
              <img
                src={logoAsset.url}
                alt="Double Lion"
                width={561}
                height={176}
                loading="lazy"
                decoding="async"
                className="h-8 sm:h-10 w-auto object-contain brightness-0 invert"
              />
            </picture>
            <p className="mt-4 sm:mt-5 font-mono text-[10px] uppercase tracking-[0.25em] text-white/60 leading-relaxed max-w-xs">
              LIMITED CRAFTED INSTRUMENTS. BUILT FOR VERSATILITY, PERFORMANCE, AND MADE FOR EVERYDAY USE AND EXPEDITIONS.
            </p>
          </div>

          {/* Navigation */}
          <div className="min-w-0 md:col-span-2 md:col-start-6">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[color:var(--color-footer-accent)] mb-4 sm:mb-5">
              Navigate
            </div>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/product/$handle"
                  params={{ handle: "6x16-binoculars" }}
                  className="font-mono text-[11px] uppercase tracking-[0.15em] text-white/85 hover:text-[color:var(--color-footer-accent)] transition-colors"
                >
                  6×16 Binoculars
                </Link>
              </li>
              <li>
                <Link to="/about" className="font-mono text-[11px] uppercase tracking-[0.15em] text-white/85 hover:text-[color:var(--color-footer-accent)] transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/story" className="font-mono text-[11px] uppercase tracking-[0.15em] text-white/85 hover:text-[color:var(--color-footer-accent)] transition-colors">
                  Backstory
                </Link>
              </li>
            </ul>
          </div>

          {/* Warranty */}
          <div className="min-w-0 md:col-span-4 md:col-start-9">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[color:var(--color-footer-accent)] mb-4 sm:mb-5">
              Warranty
            </div>
            <p className="font-mono text-[11px] leading-relaxed text-white/75 max-w-xs">
              Every Double Lion instrument is covered by a 5-year international warranty. Registration included with every purchase.
            </p>
            <div className="mt-6 font-mono text-[10px] uppercase tracking-[0.3em] text-[color:var(--color-footer-accent)] mb-2">
              Contact
            </div>
            <a
              href="mailto:info@doublelion.com"
              className="font-mono text-[11px] tracking-[0.1em] text-white/85 hover:text-[color:var(--color-footer-accent)] transition-colors"
            >
              info@doublelion.com
            </a>
            <div className="mt-4 flex flex-col gap-2">
              <Link to="/warranty" className="font-mono text-[11px] uppercase tracking-[0.15em] text-white/85 hover:text-[color:var(--color-footer-accent)] transition-colors">
                Warranty details →
              </Link>
              <Link to="/warranty/claim" className="font-mono text-[11px] uppercase tracking-[0.15em] text-white/85 hover:text-[color:var(--color-footer-accent)] transition-colors">
                Submit a claim →
              </Link>
              {OWNERS_MANUAL && (
                <a
                  href={OWNERS_MANUAL.url}
                  download
                  target="_blank"
                  rel="noopener"
                  className="font-mono text-[11px] uppercase tracking-[0.15em] text-white/85 hover:text-[color:var(--color-footer-accent)] transition-colors"
                >
                  Owner's manual (PDF) →
                </a>
              )}

            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-8 sm:mt-10 md:mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex flex-wrap items-center gap-x-4 sm:gap-x-6 gap-y-2 min-w-0">
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/55">
              © {new Date().getFullYear()} Double Lion
            </span>
            <span className="hidden sm:inline font-mono text-[10px] text-white/30">·</span>
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/55">
              All rights reserved
            </span>
          </div>
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[color:var(--color-footer-accent)] shrink-0">
            MADE IN JAPAN
          </div>
        </div>
      </div>
    </footer>
  );
}
